<div>
  <div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div>
  <div class="msTeam-modalBodyScroll" *ngIf="!loading">
    <div *ngIf=isShare style="padding-left: 15px; padding-right: 15px;">
      <sharesettings-dialog #shareSettingsDialog></sharesettings-dialog>
    </div>
    <mat-list role="list" *ngIf=!isShare>
      <div class="nodata"
        *ngIf="((folderCount == 0 && fileCount == 0)||(folders | filter: searchText :['title','createdby','firstname','lastname']).length === 0) && selectionType==0 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">{{noFilesFolders}}</div>
      </div>

      <div class="nodata"
        *ngIf="((folderCount == 0)||(folders | filter: searchText :['title','createdby','firstname','lastname']).length === 0) && selectionType==1 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">
          {{noFolders}}</div>
  
      </div>

      <div class="nodata"
        *ngIf="((fileCount == 0)||(folders | filter: searchText :['title','createdby','firstname','lastname']).length === 0) && selectionType==2 && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">       
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">
          {{noFiles}}
        </div>
    
      </div>

      <mat-list-item
        *ngFor="let item of (folders | filter: searchText :['title','createdby','firstname','lastname']);last as last"
        role="listitem">
        <mat-radio-button aria-label="Select {{item.type}} {{item.types}} {{item.title}}" [value]="item" (change)="clickedRow($event.value)"
                                (click)="clickedRow(item)">
        <div class="float-left margTop5">                         
        <mat-icon matListIcon style="width:30px;">
          <!-- <div class="row"> -->
            <!-- <mat-radio-group [(ngModel)]="highlightRow" formControlName="radiooptions"> -->
              <!-- <mat-radio-button aria-label="Select {{item.name}}" [value]="item" (change)="clickedRow($event.value)"
                                (click)="clickedRow(item)"></mat-radio-button> -->
            <!-- </mat-radio-group> -->
            <ng-template [ngIf]="item.types == 'folder'&& item.foldertype && item.foldertype=='SMART'" style="margin-bottom: 9px !important;">
              <img src="./assets/smart_folder_icon_new.svg" width="23">
            </ng-template>
            <ng-template [ngIf]="item.types == 'folder'&& item.foldertype && item.foldertype!='SMART'" style="margin-bottom: 9px !important;">
              <img src="./assets/folder.svg" width="23">
            </ng-template>
            <ng-template [ngIf]="item.types == 'file'">
              <img src="./assets/{{getFileIcon(item.type)}}_icon.svg" width="23" />
            </ng-template>
          <!-- </div> -->
        </mat-icon>
        </div>

        <span style="margin-top: 5px;" *ngIf="item.types == 'folder'" tabindex="0" matLine (keyup.enter)="getFoldersFiles(item,item.id, item.parentFolderID,item.name,true,item.type)" (click)="getFoldersFiles(item,item.id, item.parentFolderID,item.name,true,item.type)"  role="link" [attr.aria-label]="(item.types == 'folder') ? 'Open folder ' +item.title: 'Select '+item.type+ ' file '+item.title">
          <span matLine matTooltip= {{item.name}} class="span2" >{{item.name}}</span>
          <div class="arrowIcon" style="margin-top: -6px;"></div>
        <span matLine class="mat-list-item-content-smaller">
          <span>Modified on </span>{{item.modifieddate}}<span> by </span>{{item.createdby.firstname}} {{item.createdby.lastname}}
          <!-- <span [innerHTML]="getText(item.createdby.firstname,item.createdby.lastname,false) | highlight: searchText"></span> -->
        </span>
      </span>

        <span style="margin-top: 5px;" *ngIf="item.types == 'file'" matLine>
            <ng-template [ngIf]="!item.type">
              <!-- <span matLine matTooltip= {{item.name}} [innerHTML]="item.name | highlight: searchText" class="span2" ></span> -->
              <span matLine matTooltip= {{item.name}} class="span2" >{{item.name}}</span>
            </ng-template>
            <ng-template [ngIf]="item.type">
              <!-- <span matLine matTooltip= {{item.name}}.{{item.type}} [innerHTML]="getText(item.name,item.type,true) | highlight: searchText" class="span2" ></span> -->
              <span matLine matTooltip= {{item.name}}.{{item.type}}  class="span2" >{{item.name}}.{{item.type}}</span>
            </ng-template>
          <span matLine class="mat-list-item-content-smaller">
              {{item.size| filesize}},
            <span>Modified on </span>{{item.modifieddate}}<span> by </span>{{item.createdby.firstname}} {{item.createdby.lastname}}
            <!-- <span [innerHTML]="getText(item.createdby.firstname,item.createdby.lastname,false) | highlight: searchText"></span> -->
          </span>
        </span>
      </mat-radio-button>
        <mat-divider [inset]="false" class="matlist-divider" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="msTeam-modal-footer add-divider" *ngIf="!isShare && !loading">
    <button *ngIf="isButtonVisible" type="button" mat-raised-button class="msTeam-btn full-width"
      (click)='loadMore()'>
      {{loadingMessage}}
    </button>
  </div>

  <div class="global-footer">
    <div class ="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading"></div>


    <div class="msTeam-modal-footer-right" *ngIf="!loading && isUpload != true && !isShare">
      <button mat-raised-button (click)="closeDialog()" class="cancelBtn">{{cancel}}</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;" (click)="shareItem()" [disabled]="sharebutton.isDisabled"  *ngIf="errorMsg.str.length ==0" >
        {{sharebutton.sharetitle}}
      </button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;" (click)="shareItem()" [disabled]="sharebutton.isDisabled"  *ngIf="errorMsg.str.length >0">
        {{sharebutton.sharetitledefault}}
      </button>
    </div>

    <div class="msTeam-modal-footer-right" *ngIf=" !loading && isUpload ==true && !isShare">
      <button mat-raised-button (click)="moveToUpload()" class="cancelBtn">{{cancel}}</button>
      <button id="upload_btn" class="msTeam-btn" mat-raised-button style="margin-left:10px;" (click)="uploadItem()">
        {{uploadToHQ}}
      </button>
    </div>

  </div>


</div>